import { render, staticRenderFns } from "./alertModal.vue?vue&type=template&id=3be8d6d2&"
import script from "./alertModal.vue?vue&type=script&lang=js&"
export * from "./alertModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports